module.exports = __webpack_public_path__ + "media/s6Model2.739e2424.mp4";